import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = (props: ToasterProps) => (
  <Sonner
    position="top-right"
    richColors
    closeButton
    toastOptions={{
      duration: 4000,
    }}
    {...props}
  />
);

export { Toaster };
